export function anchorScroll() {
    const header = document.querySelector('.header'); // <— pas deze selector aan

    document.querySelectorAll('a[href^="#"]').forEach(link => {
        link.addEventListener('click', e => {
            const href = link.getAttribute('href');

            // voorkom gedoe met alleen "#" links
            if (!href || href === '#') return;

            const target = document.querySelector(href);
            if (!target) return;

            e.preventDefault();

            const headerHeight = header
                ? header.getBoundingClientRect().height
                : 0;

            const targetY =
                target.getBoundingClientRect().top +
                window.scrollY -
                headerHeight;

            window.scrollTo({
                top: targetY,
                behavior: 'smooth',
            });
        });
    });
}
